export default {"src":"/_next/static/media/5-banner.d3152465.gif","height":338,"width":600,"blurWidth":0,"blurHeight":0};